/**
 * The colour a congress space falls back to when the admin has set none
 * (`CongressSpace.coverColor === null`).
 *
 * It reaches two surfaces, and they carry the SAME tint:
 * - the countdown card (the congress hero), where it is the background — covered
 *   by the image on a `backdrop` / `fullArtwork` cover, but still the base layer
 *   and still what the hero's auto text-tone is measured from;
 * - the collection cards inside the congress page, via `accentColor`.
 *
 * Deliberately NOT applied to the Top Sessions card and page header (their own
 * light green) or the PDF cards (their lavender): three visual families for
 * three content natures is intended, not an inconsistency to unify later.
 *
 * Lived as the same literal in three components (RoomCongressHero,
 * RoomCongressResources, DiscoveryCongressHero) before this module existed.
 */
export const DEFAULT_COVER_COLOR = "#40b0c8";
